<template>
  <div class="contents_wrap">
    <div class="small_title_wrap">
      <h2>발송 정보</h2>
    </div>
    <ul class="filter_list">
      <li>
        <dd>
          <label>우든 포장 추가</label>
          <ul class="w50">
            <li>
              <input
                  type="checkbox"
                  id="woodenYn"
                  class="k-checkbox"
                  :checked="sendInfo.woodenYn === 'Y'"
                  @click="sendInfo.woodenYn = (sendInfo.woodenYn === 'Y' ? 'N' : 'Y');"
              >
              <label for="woodenYn" class="k-checkbox-label m"><span class="mgl10">추가</span></label>
            </li>
          </ul>
        </dd>
        <dd>
          <label>보관 위치<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  :class="{'error' : errorTarget === 'lockerId'}"
                  ref="lockerIdRef"
                  v-model="sendInfo.lockerId"
                  :data-text-field="'lockerNm'"
                  :data-value-field="'lockerId'"
                  :option-label="'거점 선택 후 선택해주세요.'"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수량<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  type="number"
                  class="w100"
                  :class="{'error' : errorTarget === 'qty'}"
                  min="0"
                  v-model="sendInfo.qty"
                  @input="sendInfo.qty=EtnersCommonUtil.cutByteLength(sendInfo.qty, 2)"
                  :placeholder="'수량을 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
        <dd>
          <label>무인 보관함 번호</label>
          <ul class="w50">
            <li>
              <input type="text"
                     v-model="sendInfo.lockerCellId"
                     :disabled="true"
                     placeholder="무인 보관함 번호">
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>비고</label>
          <ul class="w50">
            <li>
              <input type="text"
                     v-model="sendInfo.contents"
                     @input="sendInfo.contents=EtnersCommonUtil.cutByteLength(sendInfo.contents, 4000)"
                     placeholder="-">
            </li>
          </ul>
        </dd>
        <dd>
        </dd>
      </li>
    </ul>
  </div>
</template>

<script>

import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "SendUpdateRegi",
  props: {
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    lockerNmDataSource : {
      type: Array,
      required: false,
      default : function (){
        return []
      }
    }
  },
  watch: {
    'propsSendInfo': {
      handler: function (val, oldVal) {
        this.sendInfo = this.propsSendInfo
      },
      deep: true,
    },
    'lockerNmDataSource': {
      handler: function (val, oldVal) {
        this.$refs.lockerIdRef.kendoWidget().setDataSource(val)
        this.$refs.lockerIdRef.kendoWidget().value(this.sendInfo.lockerId)
        return val
      }
    }
  },
  methods: {
    getPropsSendInfo () {
      // 부모 컴포넌트(SendSave.vue)에서 호출
      const vm = this
      const sendInfo = vm.sendInfo

      // 유효성 체크
      if (EtnersCommonUtil.isEmpty(sendInfo.qty)) {
        kendo.alert('수량을 입력해주세요.')
        vm.errorTarget = 'qty'
        return
      } else if (!EtnersCommonUtil.isPositiveInteger(sendInfo.qty)) {
        kendo.alert('수량은 1이상의 숫자를 입력해주세요.')
        vm.errorTarget = 'qty'
        return
      }
      if (!!vm.$refs.lockerIdRef) {
        const lockerId = vm.$refs.lockerIdRef.kendoWidget().value()
        if (EtnersCommonUtil.isEmpty(lockerId)) {
          kendo.alert('보관 위치를 선택해주세요.')
          vm.errorTarget = 'lockerId'
          return
        }
        vm.sendInfo.lockerId = lockerId
      }
      vm.errorTarget = null
      return vm.sendInfo
    },
  },
  data () {
    const vm = this

    return {
      EtnersCommonUtil: EtnersCommonUtil,
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      sendInfo: {
        ...vm.propsSendInfo
      },
      errorTarget: null, // 유효성 체크 error 클래스 활용
    }
  }
}
</script>

<style scoped>

</style>
